import { NotScrollJournalPage } from "../../components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import Fish from "../../assets/images/MealMood/fish.png";
import styles from "./styles.module.scss";
import ZoomableKonva from "./ZoomableKonva";
import Graphics from "./graphics/Graphics";
import Buble1 from "../../assets/images/buble1.png";
import { useEffect, useState } from "react";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "shared/enums/commonEnums";
import Thinking from "../../assets/images/MealMood/thinking.png";
import DislikeRobo from "../../assets/images/MealMood/dislikeRobo.png";
import Motivate from "../../assets/images/MealMood/motivate.png";
import Hand from "../../assets/images/MealMood/hand.png";
import LikeRobo from "../../assets/images/MealMood/cool.png";
import NormRobo from "../../assets/images/MealMood/norm.png";
import MotivateNorm from "../../assets/images/MealMood/motivateNorm.png";
import MotivateCool from "../../assets/images/MealMood/motivateCool.png";
import ImageLeft from "../../assets/images/MealMood/CA_left.png";
import CalendarWrap from "./calendar/CalendarWrap";
import HandUp from "../../assets/images/MealMood/handUp.png";

const week = [
  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
    { id: 3, date: "12.01.2020" },
    { id: 4, date: "13.01.2020" },
  ],

  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
    { id: 3, date: "12.01.2020" },
    { id: 4, date: "13.01.2020" },
    { id: 5, date: "14.01.2020" },
    { id: 6, date: "15.01.2020" },
    { id: 7, date: "16.01.2020" },
  ],

  [
    { id: 1, date: "10.01.2020" },
    // { id: 2, date: '11.01.2020' },
  ],

  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
    { id: 3, date: "12.01.2020" },
    { id: 4, date: "13.01.2020" },
    { id: 5, date: "14.01.2020" },
    { id: 6, date: "15.01.2020" },
    { id: 7, date: "16.01.2020" },
  ],
];
const week1 = [
  [
    { id: 1, date: "10.01.2025" },
    { id: 2, date: "11.01.2025" },
  ],

  [
    { id: 1, date: "10.01.2025" },
    { id: 2, date: "11.01.2025" },
    { id: 3, date: "12.01.2025" },
  ],

  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
  ],

  [
    { id: 1, date: "10.01.2025" },
    { id: 2, date: "11.01.2025" },
    { id: 3, date: "12.01.2025" },
    { id: 4, date: "13.01.2025" },
    { id: 5, date: "14.01.2025" },
    { id: 6, date: "15.01.2025" },
    { id: 7, date: "16.01.2025" },
  ],
];
const week2 = [
  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
    { id: 3, date: "12.01.2020" },
    { id: 4, date: "13.01.2020" },
  ],

  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
    { id: 3, date: "12.01.2020" },
    { id: 4, date: "13.01.2020" },
    { id: 5, date: "14.01.2020" },
    { id: 6, date: "15.01.2020" },
    { id: 7, date: "16.01.2020" },
  ],

  [
    { id: 1, date: "10.01.2020" },
    // { id: 2, date: '11.01.2020' },
  ],

  [
    { id: 1, date: "10.01.2020" },
    { id: 2, date: "11.01.2020" },
    { id: 3, date: "12.01.2020" },
    { id: 4, date: "13.01.2020" },
    { id: 5, date: "14.01.2020" },
    { id: 6, date: "15.01.2020" },
    { id: 7, date: "16.01.2020" },
  ],
];
const weeks = [week, week1, week2];

export const WeekKBGUPage = () => {
  const [kbguStatus, setKbguStatus] = useState<number>(1);
  const [pageStatus, setPageStatus] = useState<number>(1);
  const [selectedDates, setSelectedDates] = useState<string[] | null>([]);

  const navigate = useNavigate();
  useEffect(() => {
    if (!selectedDates || selectedDates.length === 0) {
      setPageStatus(1);
    } else {
      setPageStatus(2);
    }

    setKbguStatus(2);
  }, [selectedDates]);

  const handleDateChange = (dates: string[]) => {
    setSelectedDates(dates);
    // console.log("Получены даты от CalendarWrap:", dates);
  };
  return (
    <div className={styles.weekkbgupage}>
      <NotScrollJournalPage
        leftContent={
          <div className={styles.containerLeft}>
            {/* <img src={PhotoLeft} alt="КБЖУ" /> */}
            <div className={styles.calendarholder}>
              <CalendarWrap onDateChange={handleDateChange} />
              <Button
                viewVariant="primary"
                className={styles.button}
                text="применить"
                onClick={() => navigate(RouterPathEnum.Auth)}
              />
            </div>
            {pageStatus === 1 && <img src={ImageLeft} alt="" />}
            {pageStatus === 2 && (
              <div className={styles.gridpink}>
                <div className={styles.firstkbgu}>
                  <div className={styles.graphicItem1}>
                    Белки
                    <Graphics />
                  </div>
                  <div className={styles.graphicItem2}>
                    Жиры
                    <Graphics />
                  </div>
                </div>
                <div className={styles.textkbgu}>
                  {kbguStatus === 1 && (
                    <h3>
                      Ничего. Завтра новый день, новая попытка. Ты справишся!
                    </h3>
                  )}
                  {kbguStatus === 2 && (
                    <h3>
                      МИССИЯ ВЫПОЛНЕНА! Награда: Твои КБЖУ в пределах нормы
                    </h3>
                  )}
                  {kbguStatus === 3 && (
                    <h3>
                      Цель не достигнута, но честь твоя чиста! Завтра снова в
                      бой!
                    </h3>
                  )}
                </div>
                <div className={styles.staticphoto}>
                  <img src={Thinking} alt="" />
                </div>
                <div className={styles.robophoto}>
                  {kbguStatus === 1 && (
                    <div>
                      <img src={DislikeRobo} alt="" />
                      <img
                        src={Motivate}
                        alt="comment"
                        className={styles.motivate}
                      />
                    </div>
                  )}
                  {kbguStatus === 2 && (
                    <div>
                      <img src={LikeRobo} alt="" />
                      <img
                        src={MotivateCool}
                        alt="comment"
                        className={styles.motivate}
                      />
                    </div>
                  )}
                  {kbguStatus === 3 && (
                    <div>
                      <img src={NormRobo} alt="" />
                      <img
                        src={MotivateNorm}
                        alt="comment"
                        className={styles.motivate}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.secondkbgu}>
                  <div className={styles.graphicItem3}>
                    Углеводы
                    <Graphics />
                  </div>
                  <div className={styles.graphicItem4}>
                    Калории
                    <Graphics />
                  </div>
                </div>
              </div>
            )}
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            {/*  */}
            {pageStatus === 1 && (
              // <img src={Fish} alt="" className={styles.fishHolder} />
              <div className={styles.titleandhandcontainer}>
                <div className={styles.bubleholder}>
                  <img src={Buble1} alt="" className={styles.buble1} />
                </div>

                <h3 className={styles.title}>Ваша неделя в деталях</h3>
                <div className={styles.handcontainer}>
                  <picture>
                    <source media="(min-width: 800px)" srcSet={Hand} />

                    <img
                      src={HandUp}
                      className={styles.hand}
                      alt="keylost"
                      loading="lazy"
                    />
                  </picture>
                  {/* <img src={Hand} alt="hand" className={styles.hand} /> */}
                  <h3>для просмотра выберите период </h3>
                </div>
                <img src={Fish} alt="" className={styles.fishHolder} />
              </div>
            )}
            {pageStatus === 2 && <ZoomableKonva weeks={weeks} />}

            <Button
              viewVariant="primary"
              className={styles.buttonBottom}
              text="вернуться назад"
              onClick={() => navigate(-1)}
            />
          </div>
        }
      />
    </div>
  );
};
